import { Grid } from "@material-ui/core";
import dayjs from "dayjs";
import React from "react";
import ProgrammeStep from "../../molecules/ProgrammeStep";

import "./ProgrammeOverview.scss";
import { UserProgrammeOverview } from "../../../types/UserProgrammeOverview";

interface Props {
  programmeOverview: UserProgrammeOverview | undefined;
}

const ProgrammeOverview: React.FC<Props> = ({ programmeOverview }: Props) => {
  const { startDate, steps } = programmeOverview;

  const calcDiffInDays = () => {
      const start = dayjs(startDate);
      const today = dayjs(new Date());
      return today.diff(start, "days");
  };

  const calcHeightProgress = () => {
    const initalPercentageAsFloat = 0.08333; // Step 0 bar = 1 week
    const daysCompleteOutOfProgrammeAsFloat = calcDiffInDays() / 84;
    const programmeCompletedPercentage =
      (daysCompleteOutOfProgrammeAsFloat + initalPercentageAsFloat) * 100;
    const cssBarTopPxProperty = "20px"; // From linked CSS file, allows correct adjustment
    const cssHeight = `calc(${programmeCompletedPercentage}% - ${cssBarTopPxProperty})`;

    if (programmeCompletedPercentage > 96) return "96%"; // Ensure green bar never is taller than navy bar
    return cssHeight;
  };

  return (
    <div className="programme-overview">
      <Grid container spacing={3}>
        <div className="programme-overview__navy"></div>
        <div
          className="programme-overview__green"
          style={{ height: calcHeightProgress() }}
        ></div>
        {steps.length > 0 &&
          steps.map((step) => {
            return (
              <Grid
                key={step.stepNumber}
                item
                xs={12}
                style={{ width: "100%" }}
              >
                <ProgrammeStep
                  currentStep={programmeOverview?.nextAction?.stepNumber}
                  programmeSlug={programmeOverview?.programme?.slug}
                  {...step}
                />
              </Grid>
            );
          })}
      </Grid>
    </div>
  );
};

export default ProgrammeOverview;
